import React from 'react';
import BlockPage from 'layout/components/BlockPage';
import BlockSection from 'sections/Block';
import FrontpageHeroSection from 'sections/FrontpageHero';
import FrontPageWrapper from './styles';
import { FooterAd } from 'components/FooterAd';

class FrontPage extends BlockPage {
  renderChildren() {
    const { content } = this.props.wordpress;

    return (
      <FrontPageWrapper>
        {content &&
          content.flexibleContent &&
          content.flexibleContent.contentBlocks.map((contentBlock, index) => {
            if (index === 0) {
              return (
                <div key={`first-${index}`}>
                  <FrontpageHeroSection key={index} pageHasAnnouncement={this.pageHasAnnouncement()}>
                    {this.renderBlock(contentBlock)}
                  </FrontpageHeroSection>
                </div>
              );
            } else if (index >= content.flexibleContent.contentBlocks.length - 1) {
              return (
                <BlockSection key={index} onVisible={() => this.updateBackgroundForIndex(index)}>
                  {this.renderBlock(contentBlock)}
                </BlockSection>
              );
            }

            return (
              <BlockSection key={index} onVisible={() => this.updateBackgroundForIndex(index)}>
                {this.renderBlock(contentBlock)}
              </BlockSection>
            );
          })}
        <BlockSection style={{ textAlign: 'center' }}>
          <FooterAd />
        </BlockSection>
      </FrontPageWrapper>
    );
  }
}

export default FrontPage;
